import { FormControl, TextField, styled } from '@mui/material';
import theme from 'theme/theme';

const RootFormControl = styled(FormControl)(() => ({
  textAlign: 'left',
  width: '100%',
}));

const RootBaseInput = styled(TextField)(() => ({
  marginTop: '5px',
  width: '100%',

  '& .MuiInputBase-root': {
    borderRadius: '16px',
    '&:hover': {
      fieldset: {
        borderColor: '#00CFC8',
      },
    },
  },

  '& .MuiInputBase-input': {
    padding: '14px 15px',
    fontFamily: 'Lato',
    fontSize: '14px',

    '&::placeholder': {
      fontSize: '16px',
      fontFamily: 'Lato',
      color: theme.headlines,
      opacity: '0.5',
    },
  },

  '& .Mui-focused': {
    fieldset: {
      borderColor: '#00CFC8 !important',
    },
  },

  '& .Mui-error': {
    fieldset: {
      borderColor: '#FF5454',
    },
  },

  '& .MuiFormHelperText-root': {
    color: '#FF5454',
    fontSize: '12px',
    fontFamily: 'Lato',
    marginLeft: 0,
  },

  fieldset: {
    outline: 'none',
    borderColor: '#D6E0EA',
  },
}));

export { RootFormControl };
export default RootBaseInput;
